import React from 'react';
import {NavLink} from 'react-router-dom';
import {Translate} from '../../config/TranslationProvider';
import {isAbsoluteUrl} from '../../helper';
import CopyrightedImage from '../partials/CopyrightedImage';

const HostInfo = ({host}) => {

    const image = host.medialist[0];

    let url = '';
    if (host.url) {
        const href = host.url;
        url = isAbsoluteUrl(href) ? href : 'http://' + href;
    }

    return (
        <div className="widget atbd_widget widget-card">
            <div className="atbd_widget_title">
                <h4><span className="la la-user" />&nbsp;<Translate value="host" /></h4>
            </div>
            <div className="widget-body atbd_author_info_widget">
                <div className="atbd_avatar_wrapper">
                    <figure>
                        {image && <CopyrightedImage image={image} size="large" alt="event_image" />}
                    </figure>
                    <div className="atbd_name_time">
                        <h4>{host.title}</h4>
                    </div>
                </div>
                <div className="atbd_widget_contact_info">
                    <ul>
                        {host.location?.address && (
                            <li>
                                <span className="la la-map-marker" />
                                <span className="atbd_info">{host.location.address}</span>
                            </li>
                        )}
                        {host.telephone && (
                            <li>
                                <span className="la la-phone" />
                                <span className="atbd_info">{host.telephone}</span>
                            </li>
                        )}
                        {host.email && (
                            <li>
                                <span className="la la-envelope" />
                                <span className="atbd_info">
                                    <a
                                        href={'mailto:' + host.email}
                                        target="_parent"
                                        aria-label="send-mail-host"
                                    >
                                        {host.email}
                                    </a>
                                </span>
                            </li>
                        )}
                        {host.url && (
                            <li>
                                <span className="la la-globe" />
                                <a
                                    href={url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="atbd_info"
                                    aria-label="link-host-website"
                                >
                                    {host.url}
                                </a>
                            </li>
                        )}
                    </ul>
                </div>
                <NavLink
                    to={'/hosts/' + host.id}
                    className="btn btn-outline-secondary btn-block"
                    aria-label="host"
                >
                    <Translate value="find_out_more" />
                </NavLink>
            </div>
        </div>
    );
};

export default HostInfo;
